import React, { useEffect, useState, useRef } from 'react';
import { Space, Table, Tag, Card, Select, Flex } from 'antd';

import { Button, Checkbox, Form, Input, Divider } from 'antd';
import ImagePicker from "components/pickers/image/MultiImagePicker"
import ProductService from 'services/product';
import { useParams, useNavigate } from "react-router"
import { useForm, useWatch } from "antd/es/form/Form";
import ProductOptionService from 'services/product_option'
import ProductVariantService from 'services/product_variant'
import { useApp } from 'contexts/app';
import InputNumber from "components/input-number"
import { PlusOutlined } from '@ant-design/icons';
import ProductOptionPicker from "components/pickers/product-option"
const service = new ProductService();
const productOptionService = new ProductOptionService();
const productVariantService = new ProductVariantService();

const AddNewProductPage = () => {
  const { id } = useParams();
  const [form] = useForm();
  const navigate = useNavigate();
  const [options, setOptions] = useState([])
  const [product, setProduct] = useState({})
  const [productOptions, setProductOptions] = useState([]);
  const [productVariants, setProductVariants] = useState([]);
  const [savedVariant, setSavedvariant] = useState([])

  const [selectedOption, setSelectedOption] = useState(null)
  const { showNotify } = useApp();
  const onFinish = async (values) => {
    if (id) {
      var created = await service.updateGeneralInfo(values);
      navigate(`/product/edit/${id}`);

    } else {
      var created = await service.create(values);
      navigate(`/product/edit/${created.id}`);
    }

    console.log('Success:', created);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  useEffect(() => {
    loadProductOptions();
  }, [])

  useEffect(() => {
    if (id) {
      loadData();
    }
  }, [id])

  useEffect(() => {
    // createProductVariants();
  }, [options])

  const loadData = async () => {
    setProduct({});
    var item = await service.get(id);
    setProduct(item);
    form.setFieldsValue(item);
    setOptions(item.options);
    setProductVariants(item.variants);
    setSavedvariant(item.variants);
  }

  const createProductVariants = () => {
    if (options.length <= 0) {
      return;
    }

    var lst = [];
    var option0 = options[0];
    var option1 = options[1];
    var optionValues0 = options[0].values;
    var optionValues1 = options[1]?.values;
    if (optionValues0) {
      var option0 = productOptions.find(x => x.id == options[0].id);
    }
    optionValues0.forEach(o => {

      var variant = {
        variant_id: option0.values.find(x => x.id == o).id,
        variant_title: option0.values.find(x => x.id == o).title,
        options: [{ id: options[0].id, value: o }],
        images: [],
        price: 0
      }
      var variantOld = savedVariant.find(x => x.variant_id == variant.variant_id);
      if (variantOld) {
        lst.push({ ...variantOld });
      } else {
        lst.push(variant);
      }


    });

    if (optionValues1) {
      var option1 = productOptions.find(x => x.id == options[1].id);
      var lst2 = [...lst]
      lst = [];
      optionValues1.forEach(o => {

        lst2.forEach(element => {
          var variant = {
            variant_id: element.variant_id + "_" + option1.values.find(x => x.id == o).id,
            variant_title: element.variant_title + " " + option1.values.find(x => x.id == o).title,
            options: [...element.options, { id: options[1].id, value: o }],
            images: [],
            price: 0
          }
          lst.push(variant)
        });



      });
    }

    // for (let index = 0; index < options.length; index++) {
    //   const element = array[index];
    //   var variant = {variant_id : element.id, options:[{id:element}]}

    // }

    setProductVariants(lst);
  }

  const loadProductOptions = async () => {
    var lst = await productOptionService.list();
    setProductOptions(lst);
  }

  const addOption = () => {
    var lst = [...options];
    var option = productOptions.find(x => x.id == selectedOption);
    lst.push({ ...option, option_values: option.values, values: [], option_values: option.values })
    setOptions(lst);
  }
  const onSelectOptionChange = (id, values) => {

    var newOptions = [...options];
    var index = newOptions.findIndex(x => x.id == id);
    newOptions[index].values = values;
    setOptions(newOptions);
  }

  const onUpdateProductVariant = async () => {

    await productVariantService.update({ id: id, options, variants: productVariants })
    showNotify("Đã cập nhật")
  }

  const onVariantImagesChange = (images, variant_id) => {

    var i = productVariants.findIndex(x => x.variant_id == variant_id);
    var newVariants = [...productVariants];
    newVariants[i].images = images;
    setProductVariants(newVariants);
  }


  const onVariantOriginalPriceChange = (price, variant_id) => {

    var i = productVariants.findIndex(x => x.variant_id == variant_id);
    var newVariants = [...productVariants];
    newVariants[i].original_price = price;
    setProductVariants(newVariants);
  }

  const removeOption = (op_id) => {
    var lst = [...options];
    var i = lst.findIndex(x => x.id == op_id);
    if (i >= 0) {
      lst.splice(i, 1);
    }

    setOptions(lst);
  }
  const inputRef = useRef(null);







  return (
    <Form
      form={form}
      name="basic"
      labelCol={{
        span: 8,
      }}
      wrapperCol={{
        span: 16,
      }}

      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <div>
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
          <Card size="small" title={`Phân loại ${product.name ?? ""}`} style={{ width: "100%" }}>
            <div>
              <Space direction="vertical" size={16} style={{ width: "100%" }}>


                {options.map(x => {
                  return (

                    <div>
                      <label>   {x.title}</label>
                      <div style={{ display: "flex", flexDirection: "row", gap: 8 }}>
                        <div style={{ flexGrow: 1, }}>

                          <ProductOptionPicker value={x.values} id={x.id} onChange={onSelectOptionChange} onAddNewValue={loadProductOptions} > </ProductOptionPicker>
                          {/* <Select
                            mode="multiple"
                            style={{ width: '100%' }}
                            placeholder={x.title}
                            value={x.values}
                            onChange={e => onSelectOptionChange(x.id, e)}
                            options={(x.option_values ?? []).map(v => ({ value: v.id, label: v.title }))}

                            dropdownRender={menu => (
                              <>
                                {menu}
                                <Divider style={{ margin: '8px 0' }} />
                                <Space style={{ padding: '0 8px 4px' }}>
                                  <Input
                                    placeholder="Tên phân loại"
                                    ref={inputRef}
                                    addonAfter={<Button size='small' type="link" icon={<PlusOutlined />} onClick={e=>addNewOption(x.id)}>
                                      Thêm mới
                                    </Button>}
                                  />

                                </Space>
                              </>
                            )}

                          /> */}

                        </div>
                        <div>
                          <Button onClick={e => removeOption(x.id)}>Xoá</Button>
                        </div>
                      </div>
                      {/* {JSON.stringify(x)} */}
                    </div>
                  )
                })}

              </Space>
            </div>

            <div style={{ display: "flex", marginTop: 16 }}>

              <div style={{ flexGrow: 1 }}>

                <Select
                  value={selectedOption}
                  style={{ width: "100%" }}
                  onChange={e => setSelectedOption(e)}

                  options={productOptions.map(x => ({ value: x.id, label: x.title }))}
                />

              </div>
              <div style={{ marginLeft: 16 }}>
                <Button onClick={addOption}>Thêm</Button>
              </div>

            </div>
            <div style={{ marginTop: 16 }}>
              <Button onClick={createProductVariants}>Tạo phân loại</Button>
            </div>
            <div style={{ marginTop: 16 }}>
              <Table pagination={false} dataSource={productVariants} columns={[
                {
                  title: 'Phân loại',
                  dataIndex: 'variant_title',
                  key: 'name',
                },

                {
                  title: 'Hình ảnh',
                  render: (_, { images, variant_id }) => {
                    return (
                      <div>

                        <ImagePicker value={images} onChange={e => onVariantImagesChange(e, variant_id)}></ImagePicker>
                      </div>
                    )
                  }


                },


                {
                  title: 'Giá gốc',
                  render: (_, { images, variant_id, original_price }) => {
                    return (
                      <div>
                        <InputNumber value={original_price} onChange={e => onVariantOriginalPriceChange(e, variant_id)} ></InputNumber>

                      </div>
                    )
                  }


                },


              ]} />
            </div>
            <div style={{ marginTop: 32 }}>
              <Flex justify='flex-end'>
                <Space>
                  <Button type='default' onClick={e => navigate(`/product/edit/${id}`)} >Back</Button>
                  <Button type='primary' onClick={onUpdateProductVariant} >Cập nhật</Button>

                </Space>
              </Flex>

            </div>

          </Card>



        </Space>
      </div>
    </Form>
  )
};
export default AddNewProductPage;